"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementDetailPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const settlement_detail_1 = require("../../sections/settlement-detail");
const react_router_dom_1 = require("react-router-dom");
const SettlementContext_1 = require("../../sections/settlement/context/SettlementContext");
const SettlementDetailPage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    return ((0, jsx_runtime_1.jsx)(SettlementContext_1.SettlementProvider, { children: (0, jsx_runtime_1.jsx)(settlement_detail_1.SettlementDetailComponent, { id: id ?? '' }) }));
};
exports.SettlementDetailPage = SettlementDetailPage;
